<div [class.showMenu]="menuOpen">
  <web-header (showMenu)="showMenu()" class="d-flex justify-content-center"></web-header>
</div>
<section class="top-section" [class.d-none]="menuOpen">
  <img class="backgroundImg" src="assets/images/home/banner/web_request_img.png" alt="">
  <img class="backgroundImgMobile" src="assets/images/home/banner/mob_web_request_img.png" alt="">
  <div class="requestSelection">
    <div class="title" #title>
      <h2> LOOKING FOR A SHIPPING CONTAINER?</h2>
      <h2 class="set2"> LOOK NO FURTHER</h2>
    </div>
    <div class="contentText"
      [class.h-none]="requestObj.request_type == TYPE_LEASE || requestObj.transaction_type != null">
      <span> WHETHER YOU'RE BUYING OR RENTING, NEW OR PRE-OWNED, BEGIN BY SELECTING THE PERFECTLY SIZED CONTAINER FOR
        YOUR NEEDS:</span>
    </div>

    <div class="buttons"
      [class.overflowX]="requestObj.request_type == TYPE_LEASE || requestObj.transaction_type != null">
      <div class="slider" [class.slide]="requestObj.request_type != null"
        [class.formSlide]="requestObj.transaction_type != null">
        <div fxFlex="100" class="toggleButton" [class.noVisibility]="requestObj.request_type != null">
          <!-- *ngIf="showtButton" -->
          <button *ngFor="let btn of requestTypeBtns" [class]="btn.class"
            (click)="selectRequestType(btn.value)">{{btn.name}}</button>

        </div>
        <!-- <div fxFlex="100" class="w-100">

          <ng-container *ngIf="requestObj.request_type !== TYPE_LEASE">
            2 button toggle-button
            <mat-button-toggle-group name="Container_Purpose" aria-label="Container Purpose"
              [ngModel]="requestObj.transaction_type" #bestView>
              <ng-container *ngFor="let btn of transactionTypeBtns">
                <mat-button-toggle *ngIf="btn.group == 'LeadRequestTransactionTypes_'+ requestObj.request_type"
                  (click)="selectTransactionType(btn.dev_value)" [value]='btn.dev_value' [class]="btn.dev_value">
                  {{btn.value}}
                </mat-button-toggle>
              </ng-container>


            </mat-button-toggle-group>

            <div class="location" *ngIf="requestObj.transaction_type != null && !containerInfo">
              <div class="vstack" fxFlex="50">
                <span *ngIf="requestObj.request_type != 'buy_sell'">Source</span>
                <span *ngIf="requestObj.request_type == 'buy_sell'">Location</span>
                <span>{{superLocationSourceLabel}}</span>
                <app-super-location fxLayout="column" [isEditable]="true" [beLight]="true"
                  [(ngModel)]="requestObj.pol_list">
                </app-super-location>

                <div class="port-errors">
                  <ul>
                    <li *ngFor="let error of requestObj.error.pol_list">
                      {{error}}
                    </li>
                  </ul>
                </div>

              </div>
              *ngIf="isShown"
              <div class="vstack" fxFlex="50" *ngIf="!(requestObj.request_type=='buy_sell')">
                <span>{{superLocationDestinationLabel}}</span>
                <span>Sell Location</span>
                <app-super-location fxLayout="column" [isEditable]="true" [beLight]="true"
                  [(ngModel)]="requestObj.pod_list">
                </app-super-location>


                <div class="port-errors">
                  <ul>
                    <li *ngFor="let error of requestObj.error.pod_list">
                      {{error}}
                    </li>
                    Changes by Mrunal
                    <li *ngFor="let error of requestObj.error.pol_list">
                      {{error}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="container-type" *ngIf="containerInfo" fxLayout="row wrap">

            <app-mat-auto-search [(ngModel)]="requestObj.container_size_type"
              [(errors)]="requestObj.error.container_size_type" [isEditable]="true" [idField]="null"
              displayField='display_name' [trim]="true" [clearable]="false" [listUrl]="containerSizeTypeUrl"
              name="container_type" placeholder="Container Type*" fxFlex="48" class="example-full-width"
              [beLight]="true">
            </app-mat-auto-search>
            <app-mat-auto-search [(ngModel)]="requestObj.condition" [(errors)]="requestObj.error.condition"
              [isEditable]="true" [idField]="null" [displayField]="'value'" [label]="'Condition*'" [name]="'condition'"
              [options]="containerConditionList?.results" [clearable]="false" [trim]="true" placeholder="Condition"
              class="example-full-width" fxFlex="48" [beLight]="true">
            </app-mat-auto-search>
            <app-number-field *ngIf="requestObj.request_type == TYPE_LEASE" [(ngModel)]="requestObj.leasing_period"
              [(errors)]="requestObj.error.leasing_period" [isEditable]="true" [minValue]="0"
              placeholder="Leasing period*" fxFlex="48" class="example-full-width" [beLight]="true">
            </app-number-field>
            <app-number-field [(ngModel)]="requestObj.quantity" [(errors)]="requestObj.error.quantity"
              [isEditable]="true" [minValue]="1" placeholder="Number of Containers*" fxFlex="48"
              class="example-full-width" [beLight]="true">
            </app-number-field>
            <app-text-field [(ngModel)]="requestObj.email" [(errors)]="requestObj.error.email" [isEditable]="true"
              placeholder="Email*" fxFlex="100" class="example-full-width" [beLight]="true"></app-text-field>
          </div>
          <div>
            <app-text-field [(ngModel)]="requestObj.email" [(errors)]="requestObj.error.email" [isEditable]="true"
              placeholder="Email" fxFlex="50" class="example-full-width" [beLight]="true"></app-text-field>
          </div>
          <div class="btn">
            <button mat-raised-button class="Cancel" *ngIf="requestObj.request_type != null" (click)="back()">Back
            </button>
            <button mat-raised-button class="Save"
              *ngIf="requestObj.request_type == TYPE_LEASE || requestObj.transaction_type != null"
              (click)="next()">Proceed
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</section>
<web-footer [class.d-none]="menuOpen"></web-footer>